export default "__VITE_ASSET__B4WyF6t7__"